export default {
  api: 'https://core.onsite7.co.uk/api',
  socket: 'https://socket.onsite7.co.uk',
  googleApiKey: 'AIzaSyAavcFM10uewQsAz4bxf3YW5L911bQJB-A',
};
